<template>
  <el-card
    class="mainCard clear-card invitedLeader"
    style="margin-bottom: 15px;"
    shadow="hover"
    :body-style="{
      display: 'flex',
      alignItems: 'center',
      boxSizing: 'border-box',
      width: '100%',
      padding: '20px',
      minHeight: '134px',
    }"
  >
    <el-row
      style="width: 100%; height: 100%; flex-wrap: wrap;"
      type="flex"
      align="middle"
      :gutter="10"
    >
      <el-col
        class="secondCol"
        :span="responsiveCol.one"
      >
        {{ leader.email }}
      </el-col>
      <el-col
        :span="responsiveCol.two"
      >
        <div v-if="leader.created_at">
          <div
            style="font-size: 12px;"
          >
            {{ $t('coach.leader.invited.sentAt') }}
          </div>
          {{ $moment(leader.created_at).format('YYYY-MM-DD') }}
        </div>
      </el-col>
      <el-col :span="responsiveCol.three">
        <div style="text-align: right;">
          {{ displayStatus }}
        </div>
      </el-col>
      <el-col
        class="thirdCol"
        :class="['mobile', 'tablet'].includes($mq) ? 'mobileMode' : 'deskMode'"
        :span="responsiveCol.four"
      >
        <el-button
          class="invitationResendBtn"
          round
          :disabled="processResend"
          :loading="processResend"
          @click.stop="confirmResend(leader.pk)"
        >
          Resend Invitation
        </el-button>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$t('coach.leader.invited.deleteInfo')"
          placement="top-end"
        >
          <el-button
            class="invitationDeleteBtn"
            icon="el-icon-delete"
            circle
            size="small"
            :disabled="processDelete"
            :loading="processDelete"
            @click.stop="confirmDelete(leader.pk)"
          />
        </el-tooltip>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import api from '@/api';

export default {
  name: 'InvitedLeader',

  props: {
    leader: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    processResend: false,
    processDelete: false,
  }),

  computed: {
    responsiveCol() {
      const col = {};
      if (['mobile', 'tablet'].includes(this.$mq)) {
        col.one = 10;
        col.two = 9;
        col.three = 5;
        col.four = 24;
      } else {
        col.one = 7;
        col.two = 4;
        col.three = 4;
        col.four = 9;
      }
      return col;
    },

    displayStatus() {
      let status = this.$t('coach.leader.invited.invited');

      if (this.leader) {
        if (this.leader.is_registered) {
          status = this.$t('coach.leader.invited.registered');
        } else if (this.leader.is_verified) {
          status = this.$t('coach.leader.invited.verified');
        }
      }

      return status;
    },
  },

  methods: {
    async confirmResend(pk) {
      this.$alert(this.$t('coach.leader.invited.confirmResend'), '', {
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.goBack'),
      }).then(() => {
        this.resendEmail(pk);
      }).catch(() => {});
    },

    async resendEmail(pk) {
      try {
        this.processResend = true;
        await api.resendLeaderInvitation(pk);
        this.$message.success(this.$t('coach.leader.invited.emailResent'));
      } catch (err) {
        console.log(err);
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.processResend = false;
      }
    },

    async confirmDelete(pk) {
      this.$alert(this.$t('coach.leader.invited.confirmDelete'), '', {
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('common.delete'),
        cancelButtonText: this.$t('common.goBack'),
      }).then(() => {
        this.deleteInvitation(pk);
      }).catch(() => {});
    },

    async deleteInvitation(pk) {
      try {
        this.processDelete = true;
        await api.deleteLeaderInvitation(pk);
        this.$message.success(this.$t('coach.leader.invited.invitationDeleted'));
        this.$emit('deleted', pk);
      } catch (err) {
        console.log(err);
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.processDelete = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .invitedLeader {
    white-space: normal;
    word-break: break-word;

    &.clear-card {
      background: var(--themeCardColor) !important;
    }

    .secondCol {
      font-weight: bold;
    }

    .thirdCol {
      display: flex;
      flex-wrap: nowrap;
      justify-content: flex-end;

      &.mobileMode {
        padding-top: 15px;
      }
    }

    .invitationResendBtn {
      padding: 13px 0;
      min-width: 160px;
      background: transparent;
      color: var(--themeFontColor);

      &:hover { background: rgba(255, 255, 255, 0.2); }
      &:active { background: rgba(255, 255, 255, 0.5); }
    }

    .invitationDeleteBtn {
      width: 40px;
      height: 40px;
      background: transparent;
      border-width: 0;
      color: var(--themeFontColor);

      &:hover { background: rgba(255, 255, 255, 0.2); }
      &:active { background: rgba(255, 255, 255, 0.5); }
    }
  }
</style>
